import h, { FunctionComponent } from 'preact';
import Currency from '../common/Currency';

const BasketTableSurcharge: FunctionComponent<BasketTableSurchargeProps> = ({ message, price, tax }) => {
    return <tr class="basket__row t__basket-item text-blue js-basket-item">
        <td colSpan={3} class="js-basket-title-cell basket__item border-left border-bottom">
            <b>{message}</b>
        </td>
        <td class="basket__unitprice border-bottom">
            {(price !== null) ? <Currency amount={price} /> : null}
        </td>
        <td className="basket__quantity border-bottom" />
        <td class="basket__total border-left border-right border-bottom">
            {(price !== null) ? <Currency amount={price} /> : null}
        </td>
    </tr>;
};

interface BasketTableSurchargeProps {
    message: string;
    price: string | null;
    tax: string | null;
}

export default BasketTableSurcharge;
